import React from "react";
import { Box } from "@mui/material";
import { SxProps, Theme } from "@mui/material/styles";
import { getIcon } from "@dishopsaas/design-system";
import getStyles from './CloseButton.styles'
import { ICONS } from "../../constants";


type CloseButtonProps = {
  onClick: () => void;
  sx?: SxProps<Theme>;
};

const CloseButton: React.FC<CloseButtonProps> = ({ onClick, sx }) => {
  const styles = getStyles();
  return (
    <Box
      onClick={onClick}
      sx={{ ...styles.commonStyle, ...sx }}>
      {getIcon(ICONS.Close, { size: 24 })}
    </Box>
  );
};

export default CloseButton;
